import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SEO } from "@/components/SEO";

export default function JoinThankYouPage() {
  return (
    <div className="min-h-screen pt-24 pb-20 flex items-center justify-center px-4" data-testid="join-thank-you-page">
      <SEO
        title="Thank You for Joining"
        description="Thank you for signing up! Welcome to the family."
        url="/join-thank-you"
        noindex={true}
      />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-lg"
      >
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center">
          <CheckCircle className="w-10 h-10 text-green-500" />
        </div>
        <h1 className="text-3xl md:text-4xl font-heading font-black text-gray-900 mb-4">
          WELCOME TO THE FAMILY
        </h1>
        <p className="text-gray-600 text-lg mb-2">
          Thank you for signing up!
        </p>
        <p className="text-gray-600 mb-8">
          We can't wait to see you at the club. Check your email for next steps and membership details.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/locations">
            <Button className="w-full sm:w-auto bg-brand-pink hover:bg-brand-pink-hover text-white font-bold uppercase tracking-wider">
              Find Your Location
            </Button>
          </Link>
          <Link to="/">
            <Button variant="outline" className="w-full sm:w-auto border-gray-300 text-gray-700 hover:bg-gray-50">
              Back to Home
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
